import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";

import { CoreEffects, CoreReducers, getLocalStorage, CoreState } from "@reco-m/core";
import { app } from "@reco-w/core-ui";

import { Namespaces as commonNamespaces } from "@reco-w/common-models";
import { articleService } from "@reco-w/article-service";
import { menuLabel } from "@reco-w/bitech-common";
import { ArticlePageSizeEnum, ARTICLE_HOT_LIST_DEFAULT_ORDERBY, ARTICLE_LIST_DEFAULT_ORDERBY, Namespaces } from "./common";

export namespace articleDetailModel {
    export const namespace = Namespaces.articleDetail;

    export const state: any = freeze(
        {
            ...CoreState,
        },
        !0
    );

    export type StateType = typeof state;

    export const reducers: ReducersMapObject = {
        ...CoreReducers,

        initState() {
            return state;
        },
    };

    export const effects: EffectsMapObject = {
        ...CoreEffects,
        /**
         * 初始化页面
         * @param { message, callback, id, listData }
         * @param { call, put }
         */
        *initPage({ message, callback, id, listData }, { call, put }) {
            try {
                yield put({ type: "initState", message });
                yield put({ type: "getArticleDetail", message, listData, id, callback });
            } catch (e) {
                yield call(message!.error, "initPage" + e.errmsg);
            }
        },
        /**
         * 获取文章详情
         * @param { message, listData, id, callback }
         * @param { call, put }
         */
        *getArticleDetail({ message, listData, id, callback }, { call, put }) {
            try {
                yield put({ type: "showLoading" });
                const articleDetail = yield call(articleService.get, id);
                let articleVM = articleDetail?.articleVM;
                yield put({ type: "handleArticleDetail", articleVM });
                yield put({ type: "getHotArticleList", catalogueId: articleVM?.catalogueId });
                yield put({ type: "getArticleList", message, data: listData, catalogueId: articleVM?.catalogueId });

                yield put({
                    type: "input",
                    data: { articleDetail: articleDetail, articleId: id },
                });

                callback && callback(articleVM);
            } catch (e) {
                yield call(message!.error, "getArticleDetail：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
        /**
         * 处理资讯详情信息，获取catalogueCode
         * @param { message, articleVM }
         * @param { call, put }
         */
        *handleArticleDetail({ message, articleVM }, { call, put }) {
            try {
                let catalogueCode;
                let title;
                if (articleVM) {
                    title = articleVM ? articleVM.title + "_" + articleVM.catalogueName : articleVM.title;
                    catalogueCode = articleVM && articleVM.catalogueCode;
                    yield put({ type: `${commonNamespaces.cmsCommon}/getHeadJson`, location: "/" + articleVM!.catalogueCode, title });
                }

                yield put({
                    type: "input",
                    data: { catalogueCode: catalogueCode },
                });
            } catch (e) {
                yield call(message!.error, "handleArticleDetail：" + e.errmsg);
            }
        },
        /**
         * 获取热门点击的资讯
         * @param { message, catalogueId }
         * @param { call, put }
         */
        *getHotArticleList({ message, catalogueId }, { call, put }) {
            try {
                const hotArticleList = yield call(articleService.getPaged, {
                    pageSize: ArticlePageSizeEnum.hotArticle,
                    pageIndex: 1,
                    parkId: getLocalStorage("parkId"),
                    orderBy: ARTICLE_HOT_LIST_DEFAULT_ORDERBY,
                    catalogueId,
                    isPublish: true,
                });

                yield put({ type: "input", data: { hotArticleList: hotArticleList.items } });
            } catch (e) {
                yield call(message!.error, "getHotArticleList：" + e.errmsg);
            }
        },
        /**
         * 获取资讯类表
         * @param { message, data, catalogueId }
         * @param { call, put }
         */
        *getArticleList({ message, data, catalogueId }, { call, put }) {
            try {
                const articleList = yield call(articleService.getPaged, {
                    catalogueId, // 动态资讯
                    isPublish: true,
                    pageIndex: 1,
                    pageSize: ArticlePageSizeEnum.all,
                    parkId: getLocalStorage("parkId"),
                    orderBy: ARTICLE_LIST_DEFAULT_ORDERBY,
                    ...data,
                });

                yield put({ type: "input", data: { articleList: articleList.items } });
            } catch (e) {
                yield call(message!.error, "getArticleList：" + e.errmsg);
            }
        },
        *getParentPathName({ data }, { put }) {
            const targetMenu = menuLabel[data];
            if (targetMenu) {
                yield put({ type: "input", data: { parentPathName: targetMenu.label } });
            }
        },
    };
}

app.model(articleDetailModel);
